
export const baseUrl = 'https://loyaltyceraapi.evolve-brands.co/api/v1/' //production url new
// export const baseUrl = 'http://loyalty.cera.api.wemonde.co/api/v1/' //staging
export const av = "1.0";
export const pt = "WEBSITE";
export const company = "1"
export const program = "1"


